import { LightTooltip } from "../Common";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

interface props {
	onCreateClick: Function;
}

export const Header = ({ onCreateClick }: props) => {
	return (
		<>
			<div className="flex flex-row justify-between items-center mb-6">
				<div className="flex items-center gap-2">
					<h2 className="m-0">Manage Holidays</h2>
					<LightTooltip title="Add Holiday">
						<AddCircleOutlineOutlinedIcon
							className="icon"
							style={{ fontSize: 32 }}
							onClick={() => onCreateClick()}
						/>
					</LightTooltip>
				</div>
			</div>
		</>
	);
};
